import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getData } from "../../services/generalService";
import { RepaymentDetailsObj } from "../../utils/types";

const initialState: RepaymentDetailsObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getRepaymentData = createAsyncThunk(
  "loans/getRepaymentDetails",
  async (url: string, thunkAPI) => {
    try {
      const data = await getData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const repaymentDetailsSlice = createSlice({
  name: "repayments",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRepaymentData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getRepaymentData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getRepaymentData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default repaymentDetailsSlice.reducer;
